const _allMensagens = [
    {
        menu: 'Todas Empresas',
        submenus: [
            {
                name: 'Quando Informa a Demanda/ é Terapia?',
                mensagens: [
                    `Qual o melhor período para falarmos?`
                ]
            },
            {
                name: 'Matrícula Incorreta/ Não Localizamos no SAP/ Contato Gestor',
                mensagens: [
                    `Neste primeiro contato precisamos ligar para você. Qual o melhor período para falarmos?`
                ]
            },
            {
                name: 'Se não Responder em 24h',
                mensagens: [
                    `Você ainda precisa de ajuda do Programa de Apoio?`
                ]
            },
            {
                name: 'Colaborador PCD',
                mensagens: [
                    `Qual o tipo de deficiência?`
                ]
            }
        ]
    },
    {
        menu: 'Santander',
        submenus: [
            {
                name: 'Qual o Horário de Atendimento?',
                mensagens: [
                    `Os profissionais ficam disponíveis para atendimento no *0800 723 4472 - PAPE SANTANDER* de segunda a sexta, dias úteis, das 8 às 22h.\n\nFora deste horário atendemos casos emergenciais.`
                ]
            },
            {
                name: 'Consigo Falar Agora/ Qualquer Horário',
                mensagens: [
                    `Entraremos em contato em breve. Fique atento! Em caso de emergência ligue para *0800 723 4472 - PAPE SANTANDER*`,
                ]
            },
            {
                name: 'Quando Informa o Período para Contato',
                mensagens: [
                    `Entraremos em contato no período de preferência, até no máximo 24 horas úteis. Fique atento! Em caso de emergência, ligue para *0800 723 4472 - PAPE SANTANDER*`,
                ]
            },
            {
                name: 'Desligados',
                mensagens: [
                    `Você pode utilizar o Programa de Apoio por 6 meses após a data de desligamento. Basta você ligar no *0800 723 4472 - PAPE SANTANDER*`,
                ]
            },
            {
                name: 'Como Funciona o Programa?',
                mensagens: [
                    `O Programa de *Apoio PAPE* é um benefício oferecido pela empresa aos funcionários e dependentes. \n\nO atendimento é realizado por uma equipe de psicólogos, assistentes sociais, nutricionistas, advogados, fisioterapeutas, personal trainer, enfermagem e pet consultor.\n\nÉ um serviço de apoio e orientação, realizado por telefone ou e-mail. Todos os atendimentos são sigilosos e gratuitos. *PAPE SANTANDER - 0800 723 4472*`,
                ]
            }
        ]
    },
    {
        menu: 'Albert Einstein',
        submenus: [
            {
                name: 'Qual o Horário de Atendimento',
                mensagens: [
                    `Os profissionais ficam disponíveis para atendimento no *0800 772 4567 - POP ALBERT EINSTEIN* de segunda a sexta, dias úteis, das 8 às 22h. Fora deste horário atendemos casos emergenciais.`
                ]
            },
            {
                name: 'Consigo Falar Agora/ Qualquer Horário',
                mensagens: [
                    `Entraremos em contato em breve. Fique atento! Em caso de emergência ligue para *0800 772 4567 - POP ALBERT EINSTEIN*`
                ]
            },
            {
                name: 'Quando Informa o Período para Contato',
                mensagens: [
                    `Entraremos em contato no período de preferência, até no máximo 24 horas úteis. Fique atento! Em caso de emergência, ligue para *0800 772 4567 - POP ALBERT EINSTEIN*`
                ]
            },
            {
                name: 'Desligados',
                mensagens: [
                    `Você pode utilizar o Programa de Apoio por 6 meses após a data de desligamento. Basta você ligar no *0800 772 4567 - POP ALBERT EINSTEIN*`
                ]
            },
            {
                name: 'Como Funciona o Programa?',
                mensagens: [
                    `O Programa de *Apoio POP* é um benefício oferecido pela empresa aos funcionários e dependentes.\n\nO atendimento é realizado por uma equipe de psicólogos, assistentes sociais, nutricionistas, advogados, fisioterapeutas, personal trainer, enfermagem e pet consultor.\n\nÉ um serviço de apoio e orientação, realizado por telefone ou e-mail. Todos os atendimentos são sigilosos e gratuitos. *POP ALBERT EINSTEIN – 0800 772 4567*`
                ]
            },
        ]
    },
    {
        menu: 'ITAÚ',
        submenus: [
            {
                name: 'Qual o Horário de Atendimento',
                mensagens: [
                    `Os profissionais ficam disponíveis para atendimento no *0800 773 2930 - FIQUE OK* de segunda a sexta, dias úteis, das 8 às 22h. Fora deste horário atendemos casos emergenciais.`
                ]
            },
            {
                name: 'Consigo Falar Agora/ Qualquer Horário',
                mensagens: [
                    `Entraremos em contato em breve. Fique atento! Em caso de emergência ligue para *0800 773 2930 - FIQUE OK*`
                ]
            },
            {
                name: 'Quando Informa o Período para Contato',
                mensagens: [
                    `Entraremos em contato no período de preferência, até no máximo 24 horas úteis. Fique atento! Em caso de emergência, ligue para *0800 773 2930 - FIQUE OK*`
                ]
            },
            {
                name: 'Desligados',
                mensagens: [
                    `Você pode utilizar o Programa de Apoio por 6 meses após a data de desligamento. Basta você ligar no *0800 773 2930 - FIQUE OK*`
                ]
            },
            {
                name: 'Como Funciona o Programa?',
                mensagens: [
                    `O Programa de Apoio *FIQUE OK* é um benefício oferecido pela empresa aos funcionários e dependentes.\n\nO atendimento é realizado por uma equipe de psicólogos, assistentes sociais, nutricionistas, advogados, fisioterapeutas, personal trainer, enfermagem e pet consultor.\n\nÉ um serviço de apoio e orientação, realizado por telefone ou e-mail. Todos os atendimentos são sigilosos e gratuitos. *FIQUE OK - 0800 773 2930*`
                ]
            }
            
        ]
    }
    
];

const getMensagens = () => _allMensagens;

module.exports = {
    getMensagens
}
